import { createAction } from '@reduxjs/toolkit';

export const updateStepResponse = createAction('UPDATE_STEP_RESPONSE');
export const resetResponses = createAction('RESET_RESPONSES');
